import { UPDATE_SEARCHTDATA_CONGNOTHANHLY } from "../../actions/CongNoThanhLy/actionTypes";

const initialState = {
  customerName: "",
  taisanCode: "",
  hopdongCode: "",
  tuNgay: "01/01/2001",
  denNgay: "01/01/4000",
  pageIndex: 1,
  pageSize: 20,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchCongNoThanhLy = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_CONGNOTHANHLY:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchCongNoThanhLy;
